import { combineReducers } from 'redux';

import listReducer from './List/reducer';
import viewReducer from './View/reducer';

const walkRouteReducer = combineReducers({
  list: listReducer,
  view: viewReducer,
});

export default walkRouteReducer;
